import { render, staticRenderFns } from "./GenerateReport.vue?vue&type=template&id=67110c1b&scoped=true&"
import script from "./GenerateReport.vue?vue&type=script&lang=js&"
export * from "./GenerateReport.vue?vue&type=script&lang=js&"
import style0 from "./GenerateReport.vue?vue&type=style&index=0&id=67110c1b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67110c1b",
  null
  
)

export default component.exports